import type { PuzzleMode } from '../../engine/types';
import { BrambleBoard } from './Board';
import {
  BRAMBLE_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  makeHint,
  moveFeedback,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type BrambleConfig,
  type BrambleMove,
  type BrambleState,
} from './logic';

export const brambleMode: PuzzleMode<BrambleState, BrambleMove, BrambleConfig> = {
  id: 'bramble',
  name: 'Bramble',
  tagline: 'Find the hidden words',
  description:
    'Hunt for words tucked into a letter grid. Tap a word’s first and last letters — across, down, or diagonally.',
  accent: 'seed',
  glyph: 'grid',
  howToPlay: [
    { title: 'Tap first and last', body: 'Tap the first letter of a word, then its last letter.' },
    { title: 'Any straight line', body: 'Words run across, down, or diagonally — forwards or backwards.' },
    { title: 'Clear the thicket', body: 'Find every word in the list, or finish to bank what you found.' },
  ],
  difficulties: BRAMBLE_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove,
  moveFeedback,
  handleKey,
  hint: makeHint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: BrambleBoard,
};
